import React from 'react';
import { Box, Chip, ListItem, Typography } from '@mui/material';
import { NavLink } from 'react-router-dom';
import { capitalizeFirst, getHighestDiscount } from '../../../hooks/utilsFn/utilsFn';
import  { useEffect, useRef } from 'react';


export default function SingleSearchResult(props) {
    const { slug, name, categories, denominations, productImages } = props.item;
    const { searchTerm ,isSelected } = props;
const resultRef = useRef(null);

useEffect(() => {
  if (isSelected && resultRef.current) {
    resultRef.current.scrollIntoView({
      block: "nearest",
      behavior: "smooth",
    });
  }
}, [isSelected]);
    const userDiscounts = denominations
        ?.flatMap(item => item?.userProductDenominationDiscounts || [])
        ?.map(item => Number(item.discountValue))
        ?.filter(value => !isNaN(value));
    const discount = getHighestDiscount(denominations);
    const Discount =
        userDiscounts?.length > 0
            ? Math.max(...userDiscounts)
            : discount;

    const discountType = denominations?.[0]?.cashbackOrDiscount

    const symbol= discountType ==="CASHBACK" ? "%" : "%"

    return (
        <NavLink
          ref={resultRef}

            to={`card-details/${slug}`}
            style={{
                display: "flex",
                justifyContent: "center",
                textDecoration: "none",
                width: "100%"
            }}
        >
            <ListItem
               sx={{
  backgroundColor: isSelected ? "#ebeef5" : "transparent",

  borderLeft: isSelected
    ? "3px solid #3b82f6"
    : "3px solid transparent",

  "&:hover": {
    backgroundColor: "#ebeef5"
  },

  display: "flex",

                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",

                    p: {
                        xs: 1,
                        sm: 1.5,
                        md: 2,
                        lg: 2,
                        xl: 2
                    },
                    width: "100%"
                }}
            >

                <Box sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    mr: 1,
                    minWidth: 0
                }}>
                    <Box
                        component="img"
                        src={productImages[0]?.url || categories?.[0]?.logo}
                        sx={{

                            width: {
                                xs: "50px",
                                sm: "65px",
                                md: "75px",
                                lg: "70px",
                                xl: "70px"
                            },
                            height: {
                                xs: "32px",
                                sm: "40px",
                                md: "45px",
                                lg: "45px",
                                xl: "45px"
                            },
                            borderRadius: 1,
                            flexShrink: 0
                        }}
                    />

                    <Typography
                        variant="subtitle1"
                        sx={{
                            ml: {
                                xs: 1,
                                sm: 2,
                                md: 2,
                                lg: 2,
                                xl: "15px"
                            },
                            fontSize: {
                                xs: "11px",
                                sm: "12px",
                                md: "14px",
                                lg: "14px",
                                xl: "13px"
                            },
                            lineHeight: 1.2,
                            fontWeight: {
                                xs: 500,
                                sm: 400,
                                md: 500,
                                lg: 500,
                                xl: 500
                            },
                            py: {
                                xl: 1
                            },
                            color: {
                                xs: "dark.main",
                                sm: "dark.main",
                                md: "dark.main",
                                lg: "dark.main",
                                xl: "primary.main"
                            },
                            textTransform: {
                                xl: "capitalize !important"
                            },
                            fontFamily: "Be Vietnam Pro",

                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis"
                        }}
                    >
                        {(() => {
                            const trimmed = searchTerm ? searchTerm.trim() : "";
                            if (!trimmed) return name;
                            const escapedTerm = trimmed.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
                            const regex = new RegExp(`(${escapedTerm})`, 'gi');
                            const parts = name.split(regex);
                            return parts.map((part, index) =>
                                regex.test(part) ? (
                                    <span
                                        key={index}
                                        style={{
                                            backgroundColor: "rgba(228, 193, 143, 0.4)",
                                            color: "#8D5A24",
                                            fontWeight: 600,
                                            padding: "1px 3px",
                                            borderRadius: "3px",
                                            fontFamily: "Be Vietnam Pro"
                                        }}
                                    >
                                        {part}
                                    </span>
                                ) : (
                                    part
                                )
                            );
                        })()}
                    </Typography>
                </Box>


                <Box sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    flexShrink: 0,
                    width: {
                        xl: "205px"
                    }
                }}>
                    <Chip
                        label={`${capitalizeFirst(discountType)} : ${Discount} ${symbol}`}
                        size="small"
                        variant="filled"
                        sx={{
                            backgroundColor: "primary.main",
                            fontWeight: 500,
                            color: "white.main",
                            minWidth: "45px",
                            fontSize: {
                                xs: "10px",
                                sm: "11px",
                                md: "13px",
                                lg: "13px",
                                xl: "13px"
                            },
                            fontFamily: "Be Vietnam Pro"
                        }}
                    />
                </Box>
            </ListItem>
        </NavLink>
    );
}